import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as actions from "../../../store/actions"

import {
  Paper, FormControl, FormControlLabel, Typography, Switch, IconButton, Checkbox, TextField
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';

import {
  DoneIconStyled, DivSubmitButtons, DivFormTitle,
} from './styles';

export default function TenantLimitActionDeadline(props) {
  const dispatch = useDispatch();

  const [editMode, setEditMode] = useState(false);
	const [hasActionsDeadlineLimiter, setHasActionsDeadlineLimiter] = useState(false);

  const [actionsDeadlineLimit, setActionDeadlineLimit] = useState(90);

	const tenant = useSelector(state => state.tenants.tenant);

  const updateTenants = async (tenantId, body) => dispatch(actions.updateTenantsSuperadmin(tenantId, body))

	useEffect(() => {
    if (tenant.hasActionsDeadlineLimiter) {
      setHasActionsDeadlineLimiter(tenant.hasActionsDeadlineLimiter)
      setActionDeadlineLimit(tenant.actionsDeadlineLimit)
    }
	}, [tenant])

	const handleClose = () => {
		setEditMode(false);
	}

	const handleSubmit = async () => {
		const body = {
      hasActionsDeadlineLimiter,
      actionsDeadlineLimit
		}

		try {
      await updateTenants(tenant._id, body)
			setEditMode(false);
		} catch (err) {
			console.log('err', err)
		}
	}

  return <>
    <Paper style={styles.container}>
              <DivFormTitle>
          <Typography variant='h6' style={styles.title}>Limite de dias para adiamento de ações</Typography>
                      <DivSubmitButtons>
                          {editMode ?
                              <>
                                  <IconButton onClick={handleClose} size="large"><CloseIcon color='error' /></IconButton>
                                  <IconButton onClick={handleSubmit} size="large"><DoneIconStyled /></IconButton>
                              </> :
                              <>
                                  <IconButton onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                              </>
                          }
                      </DivSubmitButtons>
              </DivFormTitle>

      <FormControlLabel
        control={
          <Switch
            disabled={!editMode}
            name='has-specific-time'
            checked={hasActionsDeadlineLimiter}
            onChange={event => setHasActionsDeadlineLimiter(event.target.checked)}
            color="primary"
            />
          }
        label="Definir tempo máximo para reagendamento de ações"
        style={{
          marginTop: '1rem'
        }}
      />

              {hasActionsDeadlineLimiter &&
        <FormControl variant="standard" margin='normal' disabled={!editMode}>
          <div style={{display: 'flex'}}>
              <TextField
                disabled={!editMode}
                label="Dias"
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                value={actionsDeadlineLimit}
                onChange={event => setActionDeadlineLimit(event.target.value)}
                variant="standard"
              />
            <span style={{color: !editMode ? 'rgb(170, 170, 170)' : null}}>
              Não será possível reagendar ações para datas superiores a esta quantidade de dias, contando a partir do primeiro deadline da ação.
            </span>
          </div>

        </FormControl>}
    </Paper>
  </>;
}

const styles = {
	container: {
		padding: '1rem',
		margin: '1rem 0',
	}
}
